import englishMessages from "ra-language-english";

const newEnglishMessages = {
  ...englishMessages,
  locales: {
    en: "English",
    ru: "Russian"
  },
  pages: {
    settings: {
      label: "Settings",
      appearance: {
        label: "Appearance",
        theme: "Theme",
        options: {
          theme: {
            light: "Light",
            dark: "Dark",
            auto: "Auto"
          }
        }
      },
      localization: {
        label: "Localization",
        language: "Language"
      },
      cache: {
        label: "Cache",
        download: "Download"
      },
      authorization: {
        label: "Authorization"
      }
    }
  },
  actions: {
    filter: "Filter",
    show: "Show",
  },
  notifications: {
    bulk_delete_title: "Are you sure you want to delete this record?",
    bulk_delete_content: "This action cannot be undone."
  },
  resources: {
    users: {
      name: "User |||| Users",
      fields: {
        username: "Username",
        email: "Email",
        password: "Password",
        active: "Active",
        permissions: "Permissions",
        status: "Status",
        authType: "Authentication Type",
        emailIsConfirmed: "Email Confirmed",
        goldCapss: "Gold caps",
        sparks: "Sparks",
      },
      options: {
        permissions: {
          PLAY: "Player",
          CREATE_USER: "Create user",
          EDIT_USER: "Edit user",
          DELETE_USER: "Delete user",
          CREATE_SEASON: "Create season",
          EDIT_SEASON: "Edit season",
          DELETE_SEASON: "Delete season",
        },
        authType: {
          EMAIL: "Email",
        },
      },
    },
  },
};

export default newEnglishMessages;
